<template lang="pug">
  .profile-page__main
    notification-list(
      v-if="notifications.length > 0"
      :notifications="notifications"
      :on-close-notification="closeNotification"
      :on-filter-notification="filterNotification"
    )
    .profile-page__header
      .profile-page__title
        h1.title {{ operatorPageData.title }}
    .profile-page__body
      .operator-table
        .operator-table__filter
          .form
            .form__elem
              simple-select-form(
                :list-data="statusListData"
                :default-value="defaultValues.status"
                @onChangeDefaultValue="changeSelectValue"
                type="status"
              )
            .form__elem
              simple-select-form(
                :list-data="shiftListData"
                :default-value="defaultValues.shift"
                @onChangeDefaultValue="changeSelectValue"
                type="shift"
              )
            .form__elem
              input.input.input_full(
                placeholder="Поиск по ФИО"
                v-model="defaultValues.fio"
                v-on:keyup="onKeyUpFio()"
              )
        .operator-table__table
          table-component(
            :thead-data="tableHead"
            :tbody-data="ordersData"
          )
        //- .operator-table__pagination
        //-   pagination
        //- .operator-table__button
        //-   button.button.button_paint-main.button_long
        //-     .button__text Сохранить
</template>

<script>
import {mapState, mapActions} from "vuex";

import TableComponent from "@/components/table/Table";
import Pagination from "../components/Pagination";
import NotificationList from "../components/NotificationList";
import SimpleSelectForm from "@/components/simpleSelectForm/SimpleSelectForm.vue";

export default {
  name: "OperatorRequests",
  components: {
    NotificationList,
    Pagination,
    TableComponent,
    SimpleSelectForm
  },
  data() {
    return {
      operatorPageData: {
        title: "Заявки"
      },
      shiftListData: [],
      defaultValues: {
        status: {
          value: null,
          text: "Все статусы"
        },
        shift: {
          value: null,
          text: "Все смены"
        },
        fio: ""
      },
      tableHead: [
        {
          type: "text",
          text: "Статус заявки",
          key: "statusName",
          enableClass: true,
          class: "statusClass"
        },
        {
          type: "link",
          url: "request_link",
          text: "Номер заявки",
          key: "_id"
        },
        {
          type: "text",
          text: "Кол-во баллов",
          key: "points"
        },
        {
          type: "text",
          // url: "shift_url",
          text: "Смена",
          key: "shift_name",
          cut: true,
          enableTitle: true
        },
        {
          type: "text",
          text: "Дата подачи",
          key: "date"
        },
        {
          type: "text",
          text: "ФИО",
          key: "child_name",
          cut: true,
          enableTitle: true
        }
      ],
      ordersData: [],
      notifications: [],
      typingInterval: null
    };
  },
  computed: {
    ...mapState(["catalogue"]),
    requestOrders() {
      return this.$store.getters.requestOrders();
    },
    statusListData() {
      const statusList = JSON.parse(JSON.stringify(this.catalogue.orderStatuses));
      const unnecessaryStatusList = [
        "adjustment",
        "repeated",
        "completed",
        "unknown"
      ];
      statusList.unshift({value: null, text: "Все статусы"});
      for (var i = 0; i < statusList.length; i++) {
        for (var j = 0; j < unnecessaryStatusList.length; j++) {
          if (statusList[i].value === unnecessaryStatusList[j]) {
            statusList.splice(i, 1);
          }
        }
      }
      return statusList;
    }
  },
  methods: {
    ...mapActions(["getOrders", "getShifts", "getNotifications"]),
    onKeyUpFio() {
      clearInterval(this.typingInterval);
      this.typingInterval = setInterval(() => {
        clearInterval(this.typingInterval);
        this.filterTable();
      }, 500);
    },
    closeNotification(notification) {
      this.notifications = this.notifications.filter(
        el => el._id !== notification._id
      );
    },
    filterNotification(notification) {
      if (
        notification.notification_type === 1 ||
        notification.notification_type === 3
      ) {
        this.defaultValues.status.value = "new";
        this.defaultValues.status.text = "Новая";
        this.defaultValues.status.server_value = "1";
      } else {
        this.defaultValues.status.value = "rejected_by_user";
        this.defaultValues.status.text = "Отклонена пользователем";
        this.defaultValues.status.server_value = "12";
      }
      this.filterTable();
      this.closeNotification(notification);
    },
    changeSelectValue(data, type) {
      this.defaultValues[type] = data;
      this.filterTable();
    },
    filterTable() {
      this.$root.$emit("onShowPreloader");
      const filter = {};
      if (this.defaultValues.status.value !== null) {
        filter.status = this.defaultValues.status.server_value;
      }
      if (this.defaultValues.shift.value !== null) {
        filter.campshift = this.defaultValues.shift.value;
      }
      filter.fio = this.defaultValues.fio;
      this.getOrders(filter).then(ordersData => {
        this.ordersData = ordersData.map(order => {
          order.date = new Date(order.date_created).toLocaleDateString("ru");
          order.shift_name = order.campshift.name;
          order.shift_url = `/pages/shifts/${order.campshift.id}/`;
          order.child_name = `${order.child.last_name} ${
            order.child.first_name
          } ${order.child.fathers_name}`;
          order._id = `#${order.id}`;
          order.request_link = `/pages/operator/requests/${order.id}/`;
          order.statusClass = `status ${
            this.requestOrders[order.status].value
          }`;
          order.statusName = `${this.requestOrders[order.status].text}`;
          return order;
        }, []);
        this.$root.$emit("onHidePreloader");
      });
    }
  },
  mounted() {
    this.filterTable();

    this.getShifts({
      params: {
        role: 4
      }
    }).then(shiftsData => {
      this.shiftListData.push(this.defaultValues.shift);
      const shifts = shiftsData.map(shift => ({
        text: shift.name,
        value: shift.id
      }));
      this.shiftListData.push(...shifts);
    });

    this.getNotifications().then(notData => {
      this.notifications = notData.map((notification, index) => {
        notification._id = index;
        if (notification.notification_type === 1) {
          notification.icon = require("@/assets/images/icons/notif-check.svg");
          notification.color = "turquoise";
        } else if (notification.notification_type === 2) {
          notification.icon = require("@/assets/images/icons/notif-cross.svg");
          notification.color = "orange";
        } else {
          notification.icon = require("@/assets/images/icons/notif-clock.svg");
          notification.color = "red";
        }
        return notification;
      });
    });
  }
};
</script>
